import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "./NavForDesktop.scss";
import { useStateValue } from "../context/StateProvider";
import { ShoppingCartOutlined } from "@ant-design/icons";
import NavNotification from "./NavNotification";

const NavForDesktop = (props) => {
  const [{ products, cart }, dispatch] = useStateValue();
  const [isActive, setisActive] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationLink, setNotificationLink] = useState("clickiriclick");
  const [deisgnLinkColor, setDesignLinkColor] = useState("var(--purple)");
  const [cartItemColor, setCartItemColor] = useState("var(--purple)");
  const [designLinkBold, setDesignLinkBold] = useState("Bryant-Reg");
  // const [currentPage, setCurrentPage] = useState("");

  const location = useLocation();

  useEffect(() => {
    // setCurrentPage(location.pathname)
    location.pathname === "/" || location.pathname === "/designwine"
      ? setDesignLinkColor("var(--green)")
      : setDesignLinkColor("var(--purple)");
    location.pathname === "/" || location.pathname === "/designwine"
      ? setDesignLinkBold("Bryant-Bold")
      : setDesignLinkBold("Bryant-Reg");
    location.pathname === "/cart"
      ? setCartItemColor("var(--green)")
      : setCartItemColor("var(--purple)");
  }, [location.pathname]);


  
 


  useEffect(() => {}, [location.pathname]);

  return (
    <nav
      // className="navbar is-fixed-top"
      // role="navigation"
      aria-label="main navigation"
      label="dropdown navigation"
    >
      {showNotification && (
        <NavNotification
          setShowNotification={setShowNotification}
          notificationLink={notificationLink}
        />
      )}
      {/* <div className="navbar-brand">
    
      
        <a
          onClick={() => {
            setisActive(!isActive);
          }}
          role="button"
          className={`navbar-burger burger ${isActive ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded="false"
          data-target="burgernav"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div> */}
      {/* <div className="line"></div> */}
      <div
      // id="burgernav"
      // className={`navbar-menu ${isActive ? "is-active" : ""}`}
      >
        <ul className="navbar1">
          <li className="">
            <Link
              to="/"
              onClick={(e) => {
                if (location.pathname === "/designwine") {
                  e.preventDefault();
                  setisActive(!isActive);
                  setShowNotification(true);
                  setNotificationLink("/");
                }
              }}
            >
              <img
                className="logo navbar-item"
                src="/images/new-wine-logo.png"
                alt=""
              />
            </Link>
          </li>
          <li className=" navbar-item">
            <NavLink
              className="design-link navlink navbar-item "
              style={{ color: deisgnLinkColor, fontFamily: designLinkBold }}
              to="/designwine"
              key={location.pathname}
              onClick={() => {
                setisActive(!isActive);
              }}
              // onMouseEnter={() => currentPage ===  "/" || currentPage === "/designwine" ? setDesignLinkColor("var(--green)") : setDesignLinkColor("var(--green)")}
              // onMouseLeave={() => currentPage ===  "/" || currentPage === "/designwine" ? setDesignLinkColor("var(--green)") : setDesignLinkColor("var(--purple)")}
            >
              Design My Wine
              {/* <div className="navbar-dropdown">
                {products.map((wine) => {
                  return (
                    <Link to={`/product/${wine.id}`}>
                      <a className="dropdown-item navbar-item">{wine.name}</a>
                    </Link>
                  );
                })}
              </div> */}
            </NavLink>
          </li>
          {/* <li className=" navbar-item"> */}
          {/* <NavLink className="navlink navbar-item" activeClassName="selected" to="/">
            Home
          </NavLink> */}
          {/* </li> */}
          <li className=" navbar-item">
            <NavLink
              className="navlink navbar-item"
              to="/winery"
              onClick={(e) => {
                if (location.pathname === "/designwine") {
                  e.preventDefault();
                  setisActive(!isActive);
                  setShowNotification(true);
                  setNotificationLink("/winery");
                }
              }}
            >
              Winery
            </NavLink>
          </li>

          <li className=" navbar-item">
            <NavLink
              className="navlink navbar-item"
              to="/about"
              onClick={(e) => {
                if (location.pathname === "/designwine") {
                  e.preventDefault();
                  setisActive(!isActive);
                  setShowNotification(true);
                  setNotificationLink("/about");
                }
              }}
            >
              About Us
            </NavLink>
          </li>

          <li className=" navbar-item">
            <NavLink
              className="navlink navbar-item"
              to="/contact"
              onClick={(e) => {
                if (location.pathname === "/designwine") {
                  e.preventDefault();
                  setisActive(!isActive);
                  setShowNotification(true);
                  setNotificationLink("/contact");
                }
              }}
            >
              Contact Us
            </NavLink>
          </li>
          <li className="navbar-cart navbar-item">
            <NavLink
              className="navlink navbar-item"
              to="/cart"
              onClick={(e) => {
                if (location.pathname === "/designwine") {
                  e.preventDefault();
                  setisActive(!isActive);
                  setShowNotification(true);
                  setNotificationLink("/cart");
                }
              }}
            >
              <ShoppingCartOutlined style={{ fontSize: "33px"}} />
              <div className="cart-items" style={{ color: cartItemColor }}>
                {cart.length > 0 && cart.length}
              </div>
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavForDesktop;
